export const apiBaseUrl = 'https://api.simulanis.io';
export const applicationId = "febb358f-51f0-4125-8d96-d80b0c64976c";
export const redirectUrl = "https://apps.simulanis.io";
export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
export const backend_url="https://psychometrics-backend.simulanis.io";
